import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormSliderField } from './form-slider.model';
import { FormFieldService } from '../../services/form-field.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'gio-form-slider',
  templateUrl: './form-slider.component.html',
  styleUrls: ['./form-slider.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormSliderComponent<N = any> extends FormBaseComponent<FormSliderField<N>> {
  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }

  constructor(
    private cd: ChangeDetectorRef,
    public _service: FormFieldService,
    sanitizer: DomSanitizer
  ) { super(cd, _service, sanitizer); }

  onComponentInit() {
    this.subscribe = this.service.detectChanges$.subscribe(() => {
      this.cd.detectChanges();
    })
  }
  onComponentDestroy() { }
}
